import LoginPage from '../../modules/LoginPage';
import '../../../styles/pages/_login.scss';
LoginPage.init();
